import { render, staticRenderFns } from "./bulk-add-users-result.view.vue?vue&type=template&id=7bafd430&"
import script from "./bulk-add-users-result.view.vue?vue&type=script&lang=ts&"
export * from "./bulk-add-users-result.view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports